import { theme } from '../../../styles';
import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper } from '../../../utils';

type CircleDiagramIllustrationProps = DefaultIconProps & {
  mainPercentage: number;
};

export const CircleDiagramIllustration = ({
  width = 40,
  marginLeft,
  marginRight,
  containerSize,
  mainPercentage,
}: CircleDiagramIllustrationProps) => {
  let roundedMainPercentage = Math.round(mainPercentage);

  if (roundedMainPercentage < 0) {
    roundedMainPercentage = Math.abs(roundedMainPercentage);
  } else if (isNaN(roundedMainPercentage) || roundedMainPercentage > 100) {
    roundedMainPercentage = 100;
  }

  const remainingPercentage = roundedMainPercentage;
  const strokeDashoffset = remainingPercentage * 2;
  return (
    <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
      <svg viewBox="0 0 40 40">
        <path
          d="M20 4.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
          fill="none"
          stroke={theme.colors.petroleumGreen}
          strokeWidth="8"
          strokeDasharray={`${100}, 100`}
        />
        <path
          d="M20 4.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
          fill="none"
          stroke={theme.colors.amaranth}
          strokeWidth="8"
          strokeDasharray={`${remainingPercentage}, 100`}
          strokeDashoffset={strokeDashoffset}
        />
      </svg>
    </DefaultIconWrapper>
  );
};
